<template>
    <div style="text-align: left; background-color: #f5f5f5">
        <div style="margin-bottom: 70px">
            <div class="flex flex-cross-center flex-main-center" style="height: 50vw">
                <img :src="infoData.imgUrlStr" style="height: 33vw"/>
            </div>
            <div style="padding: 15px 15px 15px 15px; background-color: white">
                <div style="font-size: 14px; color: #28405e">{{infoData.combineServiceName}}</div>
                <div style="font-size: 13px; color: #a4afbc; margin-top: 6px">{{infoData.combineServiceTitle}}</div>
                <div style="color: #ff4949; line-height: 23px; margin-top: 10px">
                    <span style="font-size: 15px">￥</span>
                    <span style="font-size: 23px">{{showPrice()}}</span>
                </div>
                <div style="background-color: #eee; height: 1px; margin-top: 10px"></div>
            </div>
            <div style="font-size: 13px; color: #a4afbc; padding-left: 15px; background-color: white">已选服务</div>
            <van-cell :value="skuResult" is-link @click.native="showSku = true"/>

            <div style="background-color: white;margin-top: 10px; min-height: 70vh">
                <div v-html="infoData.serviceDetail"></div>
            </div>
        </div>

        <div style="position: fixed; bottom: 0px; left: 0px; right: 0px; background-color: white">
            <div>
                <div style="background-color: #eee; height: 1px"></div>
                <div class="m-l-12 m-r-12 m-b-12">
                    <van-button :disabled="isIOS || hasBuyPermission != 1 || infoData.buy"
                                style="color: white; width: 100%"
                                :style="{'background-color': hasBuyPermission != 1 || infoData.buy ? '#e0e0e0' : '#07affa', 'color': hasBuyPermission != 1 || infoData.buy ? '#666' : '#fff'}"
                                @click.native="showSku = true">{{buyText()}}
                    </van-button>
                </div>
            </div>
        </div>
        <van-popup v-model="showSku" position="bottom" class="van-popup-custom">
            <div style="padding-top: 20px">
                <div style="display: flex; flex-direction: row; background-color:#fff;">
                    <div
                        style="width: 92px; height: 92px; border: #e7ebef 1px solid; border-radius: 5px;  background-color: #fff;position: relative;top:-18px;margin-left: 15px;"
                        class="flex flex-cross-center flex-main-center">
                        <img style="width: 70px; height: 70px" :src="infoData.imgUrlStr">
                    </div>
                    <div style="display: block; padding-left: 15px">
                        <div style="color: #ff4949; line-height: 18px">
                            <span style="font-size: 12px">￥</span>
                            <span
                                style="font-size: 18px">{{showPrice()}}</span>
                        </div>
                        <div style="font-size: 13px; color: #a4afbc; margin-top: 10px">
                            {{ skuResult2() }}
                        </div>
                        <div style="font-size: 14px; color: #28405e; margin-top: 6px">
                            {{infoData.combineServiceName}}
                        </div>
                    </div>
                </div>
                <div style="background-color: #eee; height: 1px"></div>
                <div style="background-color:#fff; padding: 15px">
                    <div v-if="infoData.userNUmberList && infoData.userNUmberList.length">
                        <div style="font-size: 13px; color: #596c83; background-color: white">受邀规模
                        </div>
                        <van-row style="margin-top: 15px; margin-bottom: 25px">
                            <van-col v-for="(userNumber, i) in infoData.userNUmberList" :key="i" span="6">
                                <div class="m-l-4 m-r-4"
                                     style="font-size: 12px; color: #07affa; text-align: center; border: #07affa 1px solid; border-radius: 4px; line-height: 27px"
                                     :style="{'color':userNumberIndex == i ? '#07affa' : '#28405e', 'border-color':userNumberIndex == i ? '#07affa' : '#eee'}"
                                     @click="userNumberIndex = i; userNumberChoose = userNumber;">
                                    {{userNumber.dateValue}}人
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div style="font-size: 13px; color: #596c83; background-color: white">周期选择
                    </div>
                    <van-row style="margin-top: 15px; margin-bottom: 25px">
                        <van-col v-for="(date, i) in infoData.dateList" :key="i" span="6">
                            <div class="m-l-4 m-r-4"
                                 style="font-size: 12px; color: #07affa; text-align: center; border: #07affa 1px solid; border-radius: 4px; line-height: 27px"
                                 :style="{'color':dateValueIndex == i ? '#07affa' : '#28405e', 'border-color':dateValueIndex == i ? '#07affa' : '#eee'}"
                                 @click="dateValueIndex = i; dateValueChoose = date;">
                                {{date.name}}
                            </div>
                        </van-col>
                    </van-row>
                    <!--<div style="display: flex; flex-direction: row; align-items: center">-->
                    <!--<div style="font-size: 13px; color: #596c83; background-color: white; flex-grow: 1">数量-->
                    <!--</div>-->
                    <!--<van-stepper-->
                    <!--v-model="count"-->
                    <!--integer-->
                    <!--:min="1"-->
                    <!--:max="100"-->
                    <!--:step="1"-->
                    <!--/>-->
                    <!--</div>-->
                </div>
                <div style="background-color: #eee; height: 1px"></div>
                <div style="background-color: white; padding: 15px">
                    <van-button :disabled="isIOS || hasBuyPermission != 1 || infoData.buy"
                                style="color: white; width: 100%; font-size: 15px;"
                                :style="{'background-color': hasBuyPermission != 1 || infoData.buy ? '#e0e0e0' : '#07affa', 'color': hasBuyPermission != 1 || infoData.buy ? '#666' : '#fff'}"
                                @click.native="pushPayChoose">{{buyText()}}
                    </van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import head from '@/mixins/head';
    import storeOrder from '@/mixins/store-order';
    import { mapState } from 'vuex';

    export default {
        name: 'industry-solutions-info',
        components: {},
        mixins: [head, storeOrder],
        data() {
            return {
                activeIndex: '2',
                activeSecondIndex: '2',
                radio9: '1',
                showCartDrawer: true,
                swiperOption: {
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },
                infoData: {
                    buyPrice: 0
                },
                dateValueIndex: 0,
                userNumberIndex: 0,
                dateValueChoose: {
                    dateValue: '',
                    discount: 0
                },
                userNumberChoose: '',
                showSku: false,
                count: 1,
                hasBuyPermission: 0,
                isIOS: false
            };
        },
        created() {
            // this.isIOS = /(BD-IOS)/i.test(navigator.userAgent);
            this.isIOS = !/(BD-ANDROID)/i.test(navigator.userAgent);
            this.queryAuth();
            this.inited();
            this.queryInfo();
        },
        mounted() {
        },
        watch: {
            '$route': 'inited' // 如果路由有变化，会再次执行该方法
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo
            }),
            skuResult() {
                let str = '';
                if (this.userNumberChoose) {
                    str += this.userNumberChoose.dateValue + '人';
                }
                if (str.length) {
                    str += ',';
                }
                str += this.dateValueChoose.name;
                return str;
            }
        },
        methods: {
            skuResult2() {
                let str = '';
                if (this.userNumberChoose) {
                    str += this.userNumberChoose.dateValue + '人';
                }
                if (str.length) {
                    str += ',';
                }
                str += this.dateValueChoose.name;
                return str;
            },
            inited() {
                this.setTitle(this.infoData.combineServiceTitle || '详情');
            },
            queryInfo() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    combineCodeList: this.$route.query.combineCode
                };
                this.$http.post('badu/BdServiceMarket/queryCombineServiceList.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.data && response.data.result && response.data.result.length > 0) {
                        this.infoData = response.data.result[0];
                        this.setTitle(this.infoData.combineServiceName || '详情');
                        if (this.infoData.dateList && this.infoData.dateList.length) {
                            let date = this.infoData.dateList[0];
                            this.dateValueIndex = 0;
                            this.dateValueChoose = date;
                        }
                        if (this.infoData.userNUmberList && this.infoData.userNUmberList.length) {
                            this.userNumberIndex = 0;
                            this.userNumberChoose = this.infoData.userNUmberList[0];
                        }
                    }
                }).catch(() => {
                    this.$toast.clear();
                });
            },

            number_format(number, decimals, decPoint, thousandsSep) {
                /*
                * 参数说明：
                * number：要格式化的数字
                * decimals：保留几位小数
                * dec_point：小数点符号
                * thousands_sep：千分位符号
                * */
                number = (number + '').replace(/[^0-9+-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number;
                var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
                var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
                var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
                var s = '';
                var toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.ceil(n * k) / k;
                };

                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                var re = /(-?\d+)(\d{3})/;
                while (re.test(s[0])) {
                    s[0] = s[0].replace(re, '$1' + sep + '$2');
                }

                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || '';
                    s[1] += new Array(prec - s[1].length + 1).join('0');
                }
                return s.join(dec);
            },

            pushPayChoose() {
                this.setOrderPackage({
                    combineCodeList: JSON.stringify([{
                        combineCode: this.$route.query.combineCode,
                        dateValue: this.dateValueChoose.dateValue || 1,
                        userNumber: this.userNumberChoose ? this.userNumberChoose.dateValue : 0,
                        dateType: this.dateValueChoose.type
                    }]),
                    productList: [{
                        img: this.infoData.img,
                        combineServiceTitle: this.infoData.combineServiceTitle,
                        tagList: this.infoData.tagList,
                        price: this.number_format(this.payPrice(), 2, '.', ',')
                    }],
                    total: this.payPrice()
                }, 1);
            },

            payPrice() {
                if (!this.infoData || !this.infoData.buyPrice || !this.dateValueChoose.discount) {
                    return 0;
                }
                let pricePerDate = 0;
                if (this.infoData.userNUmberList && this.infoData.userNUmberList.length) {
                    if (this.userNumberChoose) {
                        pricePerDate = this.userNumberChoose.price;
                    } else {
                        return 0;
                    }
                } else {
                    pricePerDate = this.infoData.buyPrice;
                }
                if (this.dateValueChoose.type == 1) {
                    pricePerDate = pricePerDate / 365.0;
                } else if (this.dateValueChoose.type == 2) {
                    pricePerDate = pricePerDate / 12.0;
                }
                return Math.round(pricePerDate * this.dateValueChoose.discount * this.dateValueChoose.dateValue / 100 / 100.0);
            },

            showPrice() {
                return this.number_format(this.payPrice(), 2, '.', ',');
            },

            buyText() {
                if (this.hasBuyPermission == 1) {
                    if (this.infoData.buy) {
                        return '已购买';
                    }
                    // if (/(BD-IOS)/i.test(navigator.userAgent)) {
                    if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                        return '立即购买';
                    }
                    return '请前往网页端购买';
                } else if (this.hasBuyPermission == 2) {
                    return '无购买权限';
                }
                return '权限查验中';
            },

            queryAuth() {
                let param = {};
                this.$http.post('profile/getUserBaseInfo.do', param).then((response) => {
                    if (response.data) {
                        if (response.data.authList.indexOf('BUY_APP') >= 0) {
                            this.hasBuyPermission = 1;
                        } else {
                            this.hasBuyPermission = 2;
                        }
                    }
                }).catch(() => {
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .van-popup-custom {
        background-color: transparent;
    }
</style>
